export default "__VITE_ASSET__fe5c2a7a__"